import { Box } from '@mui/material';
import { Logo } from 'common/components';

export const PrintLogo = () => (
  <Box sx={{ display: 'none', displayPrint: 'block', marginBottom: 2, marginLeft: -0.5 }}>
    <Logo variant="dark" data-testid="PrintLogo" />
  </Box>
);
